import { Component } from '@angular/core';

@Component({
  selector: 'ats-portal-redirect',
  imports: [],
  templateUrl: './portal-redirect.component.html',
  styleUrl: './portal-redirect.component.css',
})
// NOTE: dummy component to redirect to the portal until portal in logged area be implemented
export class PortalRedirectComponent {}
